
import { defineComponent, onMounted, ref, defineAsyncComponent } from 'vue';
import { useMeta } from 'quasar';
import { useRoute, useRouter } from 'vue-router';
import Area from '../boot/services/Area';
import { AreaType } from '../types';
import NotifyHelper from '../boot/NotifyHelper';

export default defineComponent({
  name: 'LoginLayout',
  components: {
    LoadingContainer: defineAsyncComponent(
      () =>
        import(
          /* webpackPrefrech: true */ '../components/layout/LoadingContainer.vue'
        )
    ),
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const area = ref<AreaType>();
    const loading = ref(true);

    const loadArea = async () => {
      area.value = await Area.discover();

      // Atualizar meta tags
      useMeta(() => ({
        title: `${route.meta.title ? `${route.meta.title as string} - ` : ''} ${
          area.value?.description || ''
        }`,
        link: {
          favicon: {
            rel: 'icon',
            href: area.value?.favicon || '',
            sizes: '32x32',
          },
        },
      }));
    };

    onMounted(async () => {
      try {
        loading.value = true;
        await loadArea();
      } catch (error) {
        await router.push('/lostArea');
        NotifyHelper.notifyError(
          'Ocorreu um erro ao carregar a área, tente novamente mais tarde'
        );
      } finally {
        loading.value = false;
      }
    });

    return {
      area,
      loading,
      year: new Date().getFullYear(),
    };
  },
});
